// extracted by mini-css-extract-plugin
module.exports = {"subtitle__container":"styles_subtitle__container__gPTvS","subtitle":"styles_subtitle__06Ox5","subtitle__tag":"styles_subtitle__tag__FA88o"};